import { computed, toValue } from "vue";
import { useI18n } from "vue-i18n";
import { resolveDatePickerLocale } from "./resolveDatePickerLocale.js";
function useDatePickerLocale(locale) {
  const { locale: i18nLocale } = useI18n();
  return computed(() => {
    const explicitLocale = toValue(locale);
    const sourceLocale = explicitLocale || i18nLocale.value;
    return resolveDatePickerLocale(sourceLocale);
  });
}
export {
  useDatePickerLocale
};
//# sourceMappingURL=useDatePickerLocale.js.map
